import { render, staticRenderFns } from "./tmSecondhand.vue?vue&type=template&id=8f0e4c7a&"
import script from "./tmSecondhand.vue?vue&type=script&lang=js&"
export * from "./tmSecondhand.vue?vue&type=script&lang=js&"
import style0 from "./tmSecondhand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports